import { BrowserInfo } from './schema';

export const getBrowserInfo = (window:Partial<Window>):BrowserInfo => ({
  url: window?.location?.href,
  userAgent: window?.navigator?.userAgent,
  screen: {
    width: window?.innerWidth || window?.document?.documentElement?.clientWidth || window?.document?.body?.clientWidth,
    height: window?.innerHeight || window?.document?.documentElement?.clientHeight || window?.document?.body?.clientHeight
  }
});